import { IndexableObject } from "./Helpers";

export const gamePiecePropertyInfo: IndexableObject = {
  width: {
    defaultValue: 100,
    sortedIndex: 0,
  },
  height: {
    defaultValue: 100,
    sortedIndex: 1,
  },
  x: {
    defaultValue: 0,
    sortedIndex: 2,
  },
  y: {
    defaultValue: 0,
    sortedIndex: 3,
  },
  displayHeight: {
    defaultValue: 100,
    sortedIndex: 4,
  },
  scaleMult: {
    defaultValue: 1,
    sortedIndex: 5,
  },
  selectable: {
    defaultValue: false,
    sortedIndex: 6,
  },
  editModeSelectable: {
    defaultValue: false,
    sortedIndex: 6.5,
  },
  displayMode: {
    defaultValue: "owningPlayerOnly",
    sortedIndex: 7,
  },
  displayLastOnly: {
    defaultValue: false,
    sortedIndex: 7.5,
  },
  image: {
    defaultValue: "",
    sortedIndex: 8,
  },
  cardBack: {
    defaultValue: "",
    sortedIndex: 9,
  },
  positions: {
    defaultValue: {
      dims: [100, 100],
    },
    sortedIndex: 10,
  },

  clipPath: {
    defaultValue: "",
    sortedIndex: 11,
  },
  filter: {
    defaultValue: "",
    sortedIndex: 12,
  },
  clickableAreas: {
    defaultValue: {},
    sortedIndex: 13,
  },
  transform: {
    defaultValue: "",
    sortedIndex: 14,
  },
  zIndex: {
    defaultValue: 100,
    sortedIndex: 15,
  },
  borderRadius: {
    defaultValue: 40,
    sortedIndex: 16,
  },
};
